import male from '@/assets/DefaultCloudzet/HomePage/rectangle_male.svg';
import female from '@/assets/DefaultCloudzet/HomePage/rectangle_female.svg';
import dmktzMale from '@/assets/DefaultCloudzet/HomePage/profile_male_dmktz.svg';
import dmktzFemale from '@/assets/DefaultCloudzet/HomePage/profile_female_dmktz.svg';

const showAvatar = {
  data: () => ({
    newAvatarPreview: '',
    avatarSrc: '',
  }),
  inject: ['isBodyAi'],
  watch: {
    profile: {
      handler() {
        this.setAvatarSrc();
      },
      immediate: true,
    },
    newAvatarPreview: {
      handler() {
        this.setAvatarSrc();
      },
      immediate: true,
    },
  },
  methods: {
    setAvatarSrc() {
      const svg = {
        male: this.isBodyAi ? dmktzMale : male,
        female: this.isBodyAi ? dmktzFemale : female,
      };

      let src;
      if (this.newAvatarPreview) {
        src = this.newAvatarPreview;
      }

      const { avatar_thumb_url: avatar, gender } = this.profile;
      if (avatar && avatar.indexOf('ic_customer_photo') < 0) {
        src = avatar;
      }

      const setDefaultAvatar = () => {
        this.avatarSrc = gender === 1 ? svg.male : svg.female;
      };

      if (src) {
        const image = new Image();
        image.src = src;
        image.onload = () => {
          this.avatarSrc = src;
        };
        image.onerror = setDefaultAvatar;
      } else {
        setDefaultAvatar();
      }
    },
  },
};

export default showAvatar;
